module.exports = __webpack_public_path__ + "static/media/slideImg5.30eaf44f.webp";